import type { ActivityAdapter } from '../../core';
import { combineFieldRows } from './combineFieldRows';
import { renderFieldRow } from './renderFieldRow';
import { toFieldRows } from './toFieldRows';

export const fieldChangesAdapter: ActivityAdapter = {
  toRows: toFieldRows,
  renderRow: renderFieldRow,
  combineRows: combineFieldRows,
};
